// extracted by mini-css-extract-plugin
module.exports = {"NewsTab":"style_NewsTab__28Ap_","TabItem":"style_TabItem__11KuK","SubTab":"style_SubTab__OZYba"};